import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { getLang, getPriceOrNull } from '../../helpers'
import { useBookingFormStore } from '../../providers/BookingFormStoreProvider'
import { IRoomType } from '../../store/data'
import {
  buildImageSrcSet,
  getImageFallbackUrls,
  resolveImageAlt,
  selectImageSource,
} from '../../utils/responsiveImage'
import Card from '../Card/Card'
import Typography from '../Typography'

type RoomTypeItemProps = {
  data: IRoomType
  onLoadRoomType: () => void
  onSelect: React.MouseEventHandler<HTMLButtonElement>
  selected?: boolean
}

const RoomTypeItem: React.FunctionComponent<RoomTypeItemProps> = ({
  data,
  onLoadRoomType,
  onSelect,
  selected = false,
}) => {
  const language = useBookingFormStore((state) => state.language)
  const price = getPriceOrNull(data.lowest_price, 'amount_per_night', language)
  const imageUrl = selectImageSource(data.variants, data.thumbnail, data.image)
  const imageSrcSet = buildImageSrcSet(data.variants)
  const category = getLang(data.category, language)

  return (
    <Card
      description={
        <Typography className="text-muted uppercase" component="span" variant="small">
          <FormattedMessage
            defaultMessage="{count, plural, =0 {No bed} one {# Bed} other {# Beds}}"
            description="Count button in Room type item component"
            values={{ count: data.beds }}
          />
        </Typography>
      }
      imageAlt={resolveImageAlt(data.alt, language, category)}
      imageFallbackUrls={getImageFallbackUrls(data.thumbnail, data.image)}
      imageHeight={data.height}
      imageSizes="(min-width: 768px) 128px, 100vw"
      imageSrcSet={imageSrcSet}
      imageUrl={imageUrl}
      imageWidth={data.width}
      onDetail={onLoadRoomType}
      onSelect={onSelect}
      price={price ?? undefined}
      selected={selected}
      title={category}
    />
  )
}

export default RoomTypeItem
